<template>
  <div class="detail">
    <GlobalInfoBar :title="title" />
    <GlobalChunk icon="order" title="订单信息" :padding="[20, 20, 20, 20]">
      <el-form ref="form" :model="form" label-width="160px">
        <template v-for="(item, index) in formItems">
          <el-form-item
            :label="item.label"
            :key="item.prop"
            v-if="!isAssociatedDisplay(item)"
            v-show="
              !item.isNullValueHiding ||
                (item.isNullValueHiding && form[item.prop])
            "
          >
            <el-button
              type="text"
              @click="viewOrder('register')"
              v-if="item.prop === 'viewOrder'"
              >查看注册订单</el-button
            >
            <span
              v-if="
                item.label == '注册订单' &&
                  idFlag &&
                  formData &&
                  formData.order &&
                  formData.order.two == '1'
              "
              style="margin-left: 20px; color: red"
              >同购</span
            >
            <span
              style="margin-left: 20px; color: red"
              v-if="
                item.label == '注册订单' &&
                  formData.order &&
                  formData.order.is_rong === 1
              "
              >蓉家保</span
            >
            <!--输入框-->
            <el-input
              v-if="item.type === 'input'"
              v-model="form[item.prop]"
              :placeholder="'请输入' + item.label"
              :disabled="item.disabled"
            ></el-input>

            <el-button
              type="primary"
              plain
              v-if="orderType === 'register' && item.prop === 'imei'"
              style="margin-left: 30px"
              @click="queryActiveTime"
              >查询激活时间
            </el-button>
            <el-button
              type="primary"
              plain
              v-if="orderType === 'register' && item.prop === 'push_imei'"
              style="margin-left: 30px"
              @click="pushImeiEdit"
              >修改
            </el-button>

            <div
              style="
                  font-size: 14px;
                  color: #666;
                  line-height: 24px;
                  margin-top: 10px;
                "
              v-if="
                orderType === 'register' && item.prop === 'imei' && imeiData
              "
            >
              <div>
                <span
                  style="
                      width: 4em;
                      display: inline-block;
                      text-align-last: justify;
                      color: #999;
                    "
                  >保修</span
                >：{{ imeiData.guarantee || "--" }}
              </div>
              <div>
                <span
                  style="
                      width: 4em;
                      display: inline-block;
                      text-align-last: justify;
                      color: #999;
                    "
                  >机型信息</span
                >：{{ imeiData.phone || "--" }}
              </div>
              <div>
                <span
                  style="
                      width: 4em;
                      display: inline-block;
                      text-align-last: justify;
                      color: #999;
                    "
                  >激活时间</span
                >：{{ imeiData.time || "--" }}
              </div>
            </div>

            <!--选择框-->
            <el-select
              v-if="
                item.type === 'select' &&
                  item.optValue &&
                  item.optLabel &&
                  !item.multiple
              "
              v-model="form[item.prop]"
              :placeholder="'请选择' + item.label"
              filterable
              :clearable="item.clearable"
              :disabled="item.disabled"
              @change="selectChange(item.relate,'ajsfg')"
            >
              <el-option
                v-for="opt in getOptions(item.optListName)"
                :key="opt[item.optValue]"
                :label="opt[item.optLabel]"
                :value="opt[item.optValue]"
              >
              </el-option>
            </el-select>

            <!--可多选-->
            <el-select
              v-if="
                item.type === 'select' &&
                  item.optValue &&
                  item.optLabel &&
                  item.multiple
              "
              :multiple="true"
              filterable
              :clearable="item.clearable"
              v-model="form[item.prop]"
              :placeholder="'请选择' + item.label"
              :disabled="item.disabled"
              @change="selectChange(item.relate)"
            >
              <el-option
                v-for="opt in getOptions(item.optListName)"
                :key="opt[item.optValue]"
                :label="opt[item.optLabel]"
                :value="opt[item.optValue]"
              >
              </el-option>
            </el-select>

            <el-select
              v-if="item.type === 'select' && !item.optValue && !item.optLabel"
              v-model="form[item.prop]"
              :placeholder="'请选择' + item.label"
              filterable
              :clearable="item.clearable"
              :disabled="item.disabled"
              @change="selectChange(item.relate)"
            >
              <el-option
                v-for="opt in getOptions(item.optListName)"
                :key="opt"
                :label="opt"
                :value="opt"
              >
              </el-option>
            </el-select>

            <!--日期框-->
            <el-date-picker
              v-if="item.type === 'date'"
              v-model="form[item.prop]"
              align="right"
              type="date"
              :placeholder="'请选择' + item.label"
              value-format="yyyy-MM-dd"
              :disabled="item.disabled"
            >
            </el-date-picker>

            <!--dateRange -->
            <el-date-picker
              v-if="item.type === 'dateRange'"
              type="daterange"
              range-separator="至"
              start-placeholder="开始日期"
              end-placeholder="结束日期"
              value-format="yyyy-MM-dd"
              v-model="temp[item.tempProp]"
              :value="[form[item.props[0]], form[item.props[1]]]"
              @change="
                (range) => {
                  dateRangeChange(range, item);
                }
              "
            >
            </el-date-picker>

            <!--textarea-->
            <el-input
              v-if="item.type === 'textarea'"
              v-model="form[item.prop]"
              type="textarea"
              :placeholder="'请填写' + item.label"
              :disabled="item.disabled"
            ></el-input>

            <div
             v-if="item.type === 'fail_exp'"
            >
              <el-input
              v-model="form.fail_exp"
              type="textarea"
              :placeholder="'请填写' + item.label"
              :disabled="item.disabled"
            ></el-input>
           <div style="color: red;" v-if="type!=51">
             {{ activationLockMsg }}
           </div>
            </div>
       

            <!--radio-->
            <el-radio-group
              v-if="item.type === 'radio' && item.options"
              v-model="form[item.prop]"
              @change="selectChange(item.relate)"
            >
              <el-radio
                v-for="opt in item.options"
                :key="opt.name"
                :label="opt.label"
                :disabled="item.disabled"
                >{{ opt.name }}
              </el-radio>
            </el-radio-group>

            <el-radio-group
              v-if="item.type === 'radio' && item.optListName"
              v-model="form[item.prop]"
              @change="selectChange(item.relate, item.hx)"
            >
              <el-radio
                style="margin-bottom: 10px"
                v-for="opt in getOptions(item.optListName)"
                :key="opt[item.optLabel]"
                :label="opt[item.optValue]"
                >{{ opt[item.optLabel] }}
              </el-radio>
            </el-radio-group>

            <!--img-->
            <template v-if="item.type === 'img'">
              <!--          order.tem_img-->
              <div>（点击图片查看大图）</div>

              <div style="display: flex">
                <el-image
                  v-if="form[item.prop]"
                  class="preview-img"
                  style="margin-right: 20px; margin-bottom: 20px"
                  :src="form[item.prop]"
                  :preview-src-list="[form[item.prop]]"
                  :data-watermark="!!item.watermark"
                  @click.stop="closePreview"
                >
                </el-image>
                <div
                  class="original-pic"
                  v-if="
                    formData[item.obj] &&
                      formData[item.obj]['old' + item.prop.replace('tem', '')]
                  "
                >
                  <el-image
                    class="preview-img"
                    :src="
                      formData[item.obj] &&
                        formData[item.obj]['old' + item.prop.replace('tem', '')]
                    "
                    :preview-src-list="[
                      formData[item.obj] &&
                        formData[item.obj][
                          'old' + item.prop.replace('tem', '')
                        ],
                    ]"
                    :data-watermark="!!item.watermark"
                    @click.stop="closePreview"
                  >
                  </el-image>
                  <div class="mark">原图</div>
                </div>

                <el-upload
                  :ref="item.prop"
                  v-if="!form[item.prop]"
                  action="#"
                  list-type="picture-card"
                  :limit="1"
                  show-file-list
                  :auto-upload="false"
                  :on-change="
                    (file) => {
                      getFile(file, item.prop);
                    }
                  "
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="img-operation">
                <el-button
                  plain
                  size="mini"
                  @click="uploadImg(item.prop)"
                  v-if="form[item.prop]"
                  >编辑
                </el-button>

                <template>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="saveOriginalImage(item.prop, item.obj)"
                    >保留原图</el-button
                  >
                  <div class="notice">
                    最多支持上传1张图片，大小不超过5M，格式为JPG或PNG
                  </div>
                </template>
              </div>
            </template>

            <!--img-->
            <template v-if="item.type === 'img2'">
              <!--          order.tem_img-->
              <!-- <div>（点击图片查看大图）</div> -->

              <div style="display: flex">
                <el-image
                  v-if="form[item.prop]"
                  class="preview-img"
                  style="margin-right: 20px; margin-bottom: 20px"
                  :src="form[item.prop]"
                  :preview-src-list="[form[item.prop]]"
                  :data-watermark="!!item.watermark"
                  @click.stop="closePreview"
                >
                </el-image>

                <el-upload
                  :ref="item.prop"
                  v-if="!form[item.prop]"
                  action="#"
                  list-type="picture-card"
                  :limit="1"
                  show-file-list
                  :auto-upload="false"
                  :on-change="
                    (file) => {
                      getFile(file, item.prop);
                    }
                  "
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="img-operation">
                <el-button
                  type="primary"
                  size="mini"
                  @click="uploadImg(item.prop)"
                  v-if="form[item.prop]"
                  >重新上传
                </el-button>
              </div>
            </template>

            <!-- 新增工单4上传 -->
            <template v-if="item.type === 'img4'">
              <div>（点击图片查看大图）</div>
              <div style="display: flex; flex-wrap: wrap;">
                <!-- <template v-if="form[item.prop] && form[item.prop].length">
                  <el-image
                    
                    class="preview-img"
                    style="margin-right: 20px; margin-bottom: 20px"
                    v-for="(imgUrl, imgIndex) in form[item.prop]"
                    :key="imgIndex"
                    :src="imgUrl"
                    :preview-src-list="form[item.prop]"
                    @click.stop="closePreview"
                  >
                  </el-image>
                </template> -->
                <el-upload
                  :ref="item.prop"
                  action="#"
                  list-type="picture-card"
                  :limit="10"
                  multiple
                  :file-list="form[item.prop] || []"
                  :auto-upload="false"
                  :on-change="
                    (file) => {
                      getFile(file, item.prop);
                    }
                  "
                  :on-remove="handleRemove"
                  :on-preview="handlePreview"
                  :on-exceed="handleExceed"
                >
                  <i slot="default" class="el-icon-plus"></i>
                </el-upload>
              </div>

              <div class="img-operation">
                <template>
                  <el-button
                    type="primary"
                    size="mini"
                    @click="setOrderImgBatch"
                    
                    >提交</el-button
                  >
                  <div class="notice">
                    最多支持上传10张图片，大小不超过5M，格式为JPG或PNG
                  </div>
                </template>
              </div>
            </template>
            <!-- img_add -->
            <template v-if="item.type === 'img_add'">
              <div>（点击图片查看大图）</div>
              <div style="display: flex" v-if="form[item.prop].length">
                <div v-for="(el, index) in form[item.prop]" :key="index">
                  <!-- <el-image class="preview-img" style="margin-right: 20px; margin-bottom: 20px" :src="el"
                    :preview-src-list="form[item.prop]">
                  </el-image> -->
                  <changePic v-model="form[item.prop][index]"></changePic>
                </div>
              </div>
            </template>

            <!--预警-->
            <template v-if="item.type === 'warning'">
              <span class="warning"
                >距离注册：<span>{{ form[item.props[0]] }}</span
                >天，手机号：<span>{{ form[item.props[1]] }}</span
                >次，身份证：<span>{{ form[item.props[2]] }}</span
                >次,IMEI码理赔次数：<span>{{ form[item.props[3]] }}</span
                >次</span
              >
            </template>

            <!-- 手机规格 -->
            <template v-if="item.type === 'ramSize'">
              <span>{{ form.ram_size }}</span>
            </template>

            <template v-if="item.type === 'insure_san'">
              <span>{{ form.insure_san }}</span>
            </template>

            <template v-if="item.type === 'claims_money'">
              <span>{{ claims_money }}</span>
            </template>

            <template v-if="item.type === 'span'">
              <span>{{ form[item.prop] }}</span>
            </template>

            <template v-if="item.type === 'claims_imgs_name'">
                <span>{{ order_claims.name }}</span>
            </template>
              <template v-if="item.type === 'claims_imgs_phone'">
                <span>{{ order_claims.phone }}</span>
            </template>
              <template v-if="item.type === 'claims_imgs_id_card'">
                <span>{{ order_claims.id_card }}</span>
            </template>
                  <template v-if="item.type === 'claims_imgs_imei'">
                <span>{{ order_claims.imei }}</span>
            </template>
              <template v-if="item.type === 'claims_imgs_brand'">
                <span>{{ order_claims.brand }}</span>
            </template>
              <template v-if="item.type === 'claims_imgs_model_name'">
                <span>{{ order_claims.model_name }}</span>
            </template>
                  <template v-if="item.type === 'claims_imgs_ram_size'">
                <span>{{ order_claims.ram_size }}</span>
            </template>
              <template v-if="item.type === 'claims_imgs_insure_san'">
                <span>{{ order_claims.insure_san }}</span>
            </template>
              <template v-if="item.type === 'claims_imgs_name_shop_name'">
                <span>{{ order_claims.shop_name }}</span>
            </template>
               <template v-if="item.type === 'claims_imgs_name_claims_money'">
                <span>{{ order_claims.claims_money }}</span>
            </template>
               <template v-if="item.type === 'claims_imgs_name_damage_title'">
                <span>{{ order_claims.damage_title }}</span>
            </template>

            <template v-if="item.type === 'new_price'">
               <el-input  @input="newPriceChange" v-model="new_price"
                :precision="2" :min="0" 
                label="请输入新机裸机价"></el-input>
            </template>

            <template v-if="item.type === 'payType'">
              <span>支付宝</span>
            </template>

            <template v-if="item.type === 'send_name'">
              <span>{{ send.send_name }}</span>
            </template>
            <template v-if="item.type === 'send_phone'">
              <span>{{ send.send_phone }}</span>
            </template>
            <template v-if="item.type === 'send_gps'">
              <span>{{ send.send_gps }}</span>
            </template>
            <template v-if="item.type === 'send_address'">
              <span>{{ send.send_address }}</span>
            </template>
            <template v-if="item.type === 'payment_name'">
              <span>{{ payment.payment_name }}</span>
            </template>
            <template v-if="item.type === 'payment_acc'">
              <span>{{ payment.payment_acc }}</span>
            </template>

       

      

            <template v-if="item.type === 'claims_imgs'">
              <div class="claims_imgs" v-if="claims_imgs" @click="claims_imgs_show = true">
              <img :src="claims_imgs[0]" alt="" style="height: 260px;width: 230px;">
              </div>
            </template>

            <!-- 权益选择--文字展示 -->
            <template v-if="item.type === 'tex'">
              <span class="warning">
                {{ form[item.prop] || "--" }}
              </span>
              <span
                class="rong"
                v-if="
                  item.prop === 'rong_address' &&
                    formData.order &&
                    formData.order.is_rong === 1
                "
                >已申请蓉家保</span
              >
            </template>
            <!--视频-->
            <video
              :src="form[item.prop]"
              controls="controls"
              v-if="item.type === 'video' && form[item.prop]"
              style="height: 400px"
            ></video>

            <photo-resubmission-order-list
              v-model="form.relation_id"
              v-if="item.type === 'photoResubmissionOrderList'"
              :table-data="formData.order && formData.order.order_list"
            ></photo-resubmission-order-list>
            <!--         append   -->
            <span class="append" v-if="item.append === 'viewOrder'">
              <el-button type="text" @click="viewOrder('register')"
                >查看注册订单</el-button
              >
              <el-button
                type="text"
                v-if="type === '13'"
                @click="viewOrder('claim')"
                >查看理赔订单</el-button
              >
            </span>

            <el-tag
              class="append"
              :type="
                ['success', 'danger'][Number(formData.order.link_send) - 1]
              "
              v-if="
                item.append === 'link_send' &&
                  formData.order &&
                  formData.order.link_send
              "
            >
              {{
                ["发送成功！", "发送失败！"][
                  Number(formData.order.link_send) - 1
                ]
              }}
            </el-tag>

            <el-tag
              type="warning"
              class="append"
              v-if="
                item.append === 'pushXi' &&
                  formData.order &&
                  formData.order.pushXi
              "
              >{{ formData.order.pushXi }}
            </el-tag>
            <span
              style="margin-left: 10px;"
              v-if="item.label == '手机型号' && queryDetail"
              >{{ queryDetail }}</span
            >
            <div v-if="item.type == 'wxpay'">
              <template v-if="formData.order && formData.order.is_wxpay">
                <div>
                  <el-link
                    v-if="formData.order.is_refund == 1"
                    type="danger"
                    :underline="false"
                    >已退款</el-link
                  >
                  <el-link
                    v-else-if="formData.order.is_refund == 2"
                    type="danger"
                    :underline="false"
                    >退款失败</el-link
                  >
                  <el-link v-else type="success" :underline="false"
                    >已付款</el-link
                  >
                  <el-button
                    v-if="formData.order.is_refund != 1"
                    type="warning"
                    size="mini"
                    style="margin-left: 20px"
                    @click="refund"
                    >退款</el-button
                  >
                </div>
              </template>
              <template v-else>无</template>
            </div>
            <el-link
              v-if="item.prop == 'imei' && item.isNew"
              type="danger"
              :underline="false"
              style="margin-left: 20px;"
              >{{ formData.order ? formData.order.new_imei_num : '' }}</el-link
            >
            <span
              v-if="item.prop === 'ram_size' && machineType == 2"
              :key="item.prop"
              style="margin-left: 10px;"
              >官网价:{{ official_price }}元</span
            ><span
              v-if="item.prop === 'ram_size' && machineType == 2"
              :key="index"
              style="margin-left: 10px;"
              >协议价:{{ price }}元</span
            >
            <template v-if="item.prop === 'ram_size' && formData.phonePrice && item.isPgzx">
              <span v-if="formData.phonePrice.official_price" style="margin-left: 10px;">官网价:{{ formData.phonePrice.official_price }}元</span>
              <span v-if="formData.phonePrice.price" style="margin-left: 10px;">协议价:{{ formData.phonePrice.price }}元</span>
            </template>
            <div v-if="item.type == 'claims'">

            </div>
          </el-form-item>

   
        </template>

        <div class="bottom-btns">
          <el-button plain @click="reset">重置</el-button>
          <el-button type="primary"
               v-if="
             !( type == '1' ||
                type == '4' ||
                type == '5' ||
                type == '19' ||
                type == '20' ||
                type == '26' ||
                type == '28' ||
                type == '29' ||
                type == '33' ||
                type == '35' ||
                type == '38' ||
                type == '42')
            "
          :loading="submitShow" @click="confirm"
            >确定</el-button
          >
          <el-button
            type="success"
            v-if="
              type == '1' ||
                type == '4' ||
                type == '5' ||
                type == '19' ||
                type == '20' ||
                type == '26' ||
                type == '28' ||
                type == '29' ||
                type == '33' ||
                type == '35' ||
                type == '38' ||
                type == '42'
            "
            @click="setorderJudge"
            >审核</el-button
          >
        </div>
      </el-form>
    </GlobalChunk>
    <el-dialog
      title="管理员选择"
      :visible.sync="orderJudgeVisible"
      width="600px"
    >
      <el-form label-position="top">
        <el-form-item label="选择可提供验证管理员">
          <el-select
            v-model="orderJudgeValue"
            placeholder="请选择可提供验证管理员"
          >
            <el-option
              v-for="item in orderJudgeOptions"
              :key="item.admin_id"
              :label="item.user_name"
              :value="item.admin_id"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="动态码">
          <el-input
            v-model="verifyCodeValue"
            placeholder="请输入动态码"
          ></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="orderJudgeVisible = false">取 消</el-button>
        <el-button type="primary" @click="submitverifyCode()">确 定</el-button>
      </span>
    </el-dialog>
    <GlobalChunk
      style="margin-top: 20px"
      icon="order"
      title="注册信息"
      :padding="[20, 20, 20, 20]"
    >
      <GlobalTable
        ref="GlobalTable"
        :columns="tableColumns"
        :data="[formData.member || {}]"
        :isPagination="false"
      >
        <el-table-column label="微信头像" slot="headimg" align="center">
          <template slot-scope="{ row }">
            <el-image
              class="head-img"
              :src="row.headimg"
              :preview-src-list="[row.headimg]"
              @click.stop="closePreview"
            >
            </el-image>
          </template>
        </el-table-column>
        <el-table-column label="操作" slot="operation" align="center">
          <template slot-scope="{ row }">
            <el-button
              type="success"
              @click="sendMessageToWX(row)"
              size="mini"
              style="border-radius: 50px"
              >微信发送消息
            </el-button>
          </template>
        </el-table-column>
      </GlobalTable>
    </GlobalChunk>

    <GlobalChunk
      hidden
      style="margin-top: 20px"
      icon="order"
      title="人保回调"
      :padding="[20, 20, 20, 20]"
    >
      <div class="picc-callback" v-if="piccCallbackType === 1">
        <div class="item">
          <div class="name">UUD：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">返回信息：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">insureid：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">创建时间：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">保单号：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">回调时间：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">返回码：</div>
          <div class="value"></div>
        </div>
        <div class="item">
          <div class="name">人保推送：</div>
          <div class="value">
            <el-button size="mini" type="primary">点击推送</el-button>
          </div>
        </div>
      </div>
      <!--todo-->
      <el-button v-if="piccCallbackType === 2" type="primary">提交</el-button>
    </GlobalChunk>

    <div
      class="other-info"
      :style="{
        marginLeft: formItems[0] && formItems[0].append ? '200px' : '',
      }"
    >
      <div class="sub-insurance" v-if="formData.son && formData.son.length">
        <div class="title">
          注册子保险信息
          <span class="total-cost" v-if="formData.order.cost_price"
            >合计成本：￥{{ formData.order.cost_price }}</span
          >
        </div>
        <div v-for="(item, index) in formData.son" :key="index">
          <div style="margin: 10px 0; white-space: nowrap">
            {{ item.son_name }}（{{ item.years }}）<span
              v-if="item.select"
              style="font-weight: bold"
              >【理赔选择】</span
            >
          </div>
          <div style="font-size: 14px; color: #999">
            <span style="margin-right: 20px" v-if="isShowPriceRange(item)"
              >价位段：{{ item.min_price }}-{{ item.max_price }}</span
            >
            <span style="margin-right: 20px" v-if="item.type === 1"
              >是否是Pro版本：{{ item.is_pro ? "是" : "否" }}</span
            >
            <span>成本：￥{{ item.cost_price }}</span>
          </div>
        </div>
      </div>
      <div class="sub-insurance" v-if="formData.order && formData.order.choose">
        <div class="title">附加保险</div>
        <div style="margin: 10px 0; white-space: nowrap">
          <span>{{ formData.order.vice_card_name }}</span>
        </div>
        <div style="font-size: 14px; color: #999">
          <span
            style="margin-right: 20px"
            v-if="formData.order.vice_card_secret"
            >卡密：{{ formData.order.vice_card_secret }}</span
          >
          <span style="margin-right: 20px" v-if="formData.order.vice_card_num"
            >卡号：{{ formData.order.vice_card_num }}</span
          >
        </div>
      </div>
      <div
        class="sub-insurance"
        v-if="formData.order && formData.order.two && formData.twoOrder"
      >
        <div class="title">同购保险</div>
        <div v-for="item in formData.twoOrder" :key="item.order_id">
          <div style="margin: 10px 0; white-space: nowrap">
            <span>{{ item.card_name }}</span>
          </div>
          <div style="font-size: 14px; color: #999">
            <span style="margin-right: 20px" v-if="item.card_secret"
              >卡密：{{ item.card_secret }}</span
            >
            <span style="margin-right: 20px" v-if="item.card_num"
              >卡号：{{ item.card_num }}</span
            >
          </div>
          <a
            :href="`/order/detail/${item.order_mold}/${item.order_id}`"
            target="_blank"
            style="font-size: 14px; display: inline-block; margin-top: 10px"
            >{{ item.order_sn }}</a
          >
        </div>
      </div>

      <div
        class="photo-resubmission"
        v-if="formData.order && formData.order.make_img"
      >
        <div class="title" style="margin-bottom: 10px">照片补交</div>
        <el-image
          class="preview-img"
          :src="formData.order.make_img"
          :preview-src-list="[formData.order.make_img]"
          @click.stop="closePreview"
        >
        </el-image>
        <p>
          <a
            :href="`/order/detail/21/${formData.order.make_id}`"
            target="_blank"
            style="width: 148px; text-align: center; display: inline-block"
            >查看补交订单</a
          >
        </p>
      </div>
    </div>

    <el-dialog title="提示" :visible.sync="centerDialogVisible" width="400px">
      <span>{{ dialogText }}</span>
      <span slot="footer">
        <el-button type="primary" @click="goback()">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="照片预览" :visible.sync="claims_imgs_show" width="700px">
      <el-carousel trigger="click" height="650px">
            <el-carousel-item v-for="item in claims_imgs" :key="item">
              <div class="dialog_img">
                <img :src="item" alt=""  style="width: auto; height: auto; max-width: 70%;max-height: 70%;">
              </div>
            </el-carousel-item>
          </el-carousel>

    </el-dialog>

    <el-dialog :visible.sync="dialogVisible">
      <div class="previewImgBox">
        <div class="othInfo">
          <div v-show="form.card_secret">卡密：{{ form.card_secret }}</div>
          <div v-show="form.card_num">卡号：{{ form.card_num }}</div>
          <div v-show="form.imei">IMEI码：{{ form.imei }}</div>
          <div v-show="form.card_name">销售商家：{{ form.card_name }}</div>
        </div>
        <img width="100%" :src="dialogImageUrl" alt="">
      </div>
    </el-dialog>
  </div>
</template>

<script>
import api from "@/utils/request";
import { orderImgBatch } from "@/utils/request";
import { wxRefund } from "@/utils/request/partnerManage";
import dateFormat from "@/utils";
import PhotoResubmissionOrderList from "./components/photoResubmissionOrderList";
// import { Switch } from "element-ui";
import changePic from "./components/changePic.vue";
import { type } from "./orderType1";

export default {
  name: "index",
  components: { PhotoResubmissionOrderList, changePic },
  props: {
    type: [String, Number],
    orderId: [String, Number],
  },
  data() {
    return {
      cardIddata: "",
      submitShow: false,
      centerDialogVisible: false,
      dialogText: "",
      //处理前的数据
      formData: {},
      //表单项配置
      formItems: [],
      form: {},
      title: "",
      orderType: "",

      brandList: [],
      modelList: [],
      gearList: [],
      RAMList: [],
      IDcard: [
        { name: "大陆身份证", status: 1 },
        { name: "港澳天身份证", status: 2 },
      ],
      netStandardList: [],
      phoneStatusList: [],
      phoneScreenStatusList: [],
      serviceList: [],
      serviceScreenList: [
        "免费换屏幕",
        "免费换后摄",
        "免费换后盖",
        "免费换电池",
        "质量问题换机",
      ],
      serviceScreenList2: [
        "免费换屏幕",
        "免费换后盖",
        "免费换电池",
        "免费延保",
      ],
      serviceScreenList3: [
        "免费换屏幕",
        "免费换后盖",
        "免费换电池",
        "免费延保",
        "折抵换机",
        "进水保修",
      ],
      maintainList: ["在购机门店维修", "本地维修点维修", "邮寄至成都总部维修"],
      statusList: [],
      personalReimbursementList: [
        { name: "是", value: 1 },
        { name: "否", value: 0 },
      ],
      changeMethodList: [],
      changeIMEIReasonList: [],
      changeIMEITypeList: [],
      repairTypeList: [],
      idFlag: false,
      repairMethodList: [],
      iphoneServeList: [],
      upServerList: [],
      androidServeList: [],
      iphoneNnhxServeList: [],
      androidNnhxServeList: [],
      isUpgradeList: ["同代同型换新机", "迭代升级换新机"],
      photoResubmissionTypeList: [],
      logisticsList: [],
      orderTypeList: [
        { id: "01", name: "个人" },
        { id: "31", name: "商家" },
      ],
      chooseList: [
        { id: 1, name: "是" },
        { id: 0, name: "否" },
      ],

      tableColumns: [],
      tableData: [],
      piccCallbackType: "",
      temp: {},
      imeiData: null,
      queryDetail: "",
      official_price: "", //官网价
      price: "", //协议价
      machineType: 1, //1 ios,2安卓
      orderJudgeVisible: false,
      orderJudgeOptions: [],
      orderJudgeValue: "",
      verifyCodeValue: "",
      payment:{},
      send:{},
      claims_imgs:[],
      claims_imgs_show:false,
      claims_money:'',
      activationLockMsg:'',
      order_claims:[],
      new_price:0,

      // 工单4多图
      dialogImageUrl: '',
      dialogVisible: false,
    };
  },
  computed: {
    getOptions() {
      return (optsName) => {
        return this[optsName];
      };
    },
    isAssociatedDisplay() {
      return (item) => {
        //特殊先处理
        if (item.associatedDisplay === "is_up") {
          let flag = item.showValueList.indexOf(this.form.is_up) === -1;
          if (flag) {
            this.form.new_model = "";
            this.form.new_ram = "";
          }
          return flag;
        }

        if (item.showValueList) {
          let flag =
            item.showValueList.indexOf(this.form[item.associatedDisplay]) ===
            -1;
          //如果隐藏，把值清空
          if (flag) {
            this.form[item.prop] = "";
          }
          return flag;
        }
        if (item.hideValueList) {
          return (
            item.hideValueList.indexOf(this.form[item.associatedDisplay]) !== -1
          );
        }
        return false;
      };
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    $route() {
      this.init();
    },
 
  },
  methods: {

    newPriceChange(value){
       // 正则表达式：允许数字和最多两位小数
      const reg = /^\d*\.?\d{0,2}$/;

      if (!reg.test(value)) {
        // 截取符合规则的部分
        const match = value.match(/^\d*\.?\d{0,2}/);
        this.new_price = match ? match[0] : '';
      } else {
        this.new_price = value;
      }

        setTimeout(() => {
            this.form.money = (parseFloat(this.new_price - this.form.claims_money) || 0).toFixed(2) 
            if (this.form.money < 0) {
              this.form.money = 0
            }
          
        }, 100);
    },
    setorderJudge() {
      console.log("orderId");
      api
        .orderJudge({
          order_id: this.orderId,
        })
        .then((res) => {
          if (res.data.is_verify == 0) {
            this.confirm();
          } else {
            this.orderJudgeVisible = true;
            this.orderJudgeOptions = res.data.admin;
          }
        });
    },
    submitverifyCode() {
      api
        .verifyCode({
          admin_id: this.orderJudgeValue,
          code: this.verifyCodeValue,
        })
        .then((res) => {
          this.confirm();
          this.orderJudgeVisible = false;
        });
    },
    // push_imei修改
    pushImeiEdit() {
      console.log(this.form.push_imei, "22222222");
      console.log("111111111");
      api
        .changeOrderImei({
          order_id: this.formData.order.order_id,
          push_imei: this.form.push_imei,
        })
        .then((res) => {
          this.$message.success((res && res.msg) || "修改成功");
        });
    },
    init() {
      this.getOrder();
      //获取配置
      let currentForm = require(`./orderType${this.type}.js`);

      this.formItems = currentForm.form;
      this.idFlag = currentForm.idFlag;
      this.tableColumns = currentForm.tableColumns;
      this.piccCallbackType = currentForm.piccCallbackType;
      this.orderType = currentForm.type || "";
      let title = currentForm.name + "订单详情";
      this.title = title;
      window.document.title = title;
    },
    getOrder() {
      api.orderInfo({ mold: this.type, order_id: this.orderId }).then((res) => {
        if (res.code == 233) {
          this.dialogText = res.msg;
          this.centerDialogVisible = true;
        } else {
          console.log(res);
          const {order_claims} = res.data
          this.order_claims = order_claims || []
          let claims_money_loc = []
          const {payment,send,claims_money,claims_imgs,new_price} = res.data.order
          claims_money_loc = claims_imgs || []
          if(order_claims){
          const {claims_imgs} = order_claims
            claims_money_loc = claims_imgs
          }
          this.new_price = new_price
          this.payment = payment
          this.send = send
          this.claims_imgs = claims_money_loc||[]
          this.claims_money = claims_money
          this.cardIddata = res.data || {};
          this.queryDetail = res.data.query;
          let formData = res.data || {};
          this.formData = formData;
          this.official_price = this.formData.phonePrice?.official_price || "";
          this.price = this.formData.phonePrice?.price || "";
          this.machineType = this.formData.order.type;
          let form = {};
          this.formItems.forEach((item) => {
            if(item.prop === 'tem_work4'){
              form[item.prop] = (formData.order[item.prop] || []).map(r => ({ url: r }));
            } else if (formData[item.obj] && item.prop) {
              form[item.prop] = formData[item.obj][item.prop];
              //临时prop，比如时间范围选择需要起始时间两个属性生成一个临时属性
            } else if (item.tempProp) {
              let tempProp = "";
              if (
                item.tempProp === "dateRange_term_time" ||
                item.tempProp === "dateRange_term_time2"
              ) {
                tempProp = [
                  formData[item.obj][item.props[0]] || "",
                  formData[item.obj][item.props[1]] || "",
                ];
              }
              this.$set(this.temp, item.tempProp, tempProp);
              item.props.forEach((p) => {
                form[p] = formData[item.obj][p];
              });
            }
            //通过optListName获取数组
            if (item.optListName) {
              this.getListByName(item.optListName);
            }
          });
          this.form = form;
          this.gearList = formData.order.select_gear;

          if (res.data.options) {
            let statusList = [];
            Object.keys(res.data.options).forEach((key) => {
              let isNumberKey = new RegExp(/^\d+$/).test(key);
              statusList.push({
                status: isNumberKey ? parseInt(key) : key,
                name: res.data.options[key],
              });
            });
            this.statusList = statusList;
          }
        }
      });
    },
    goback() {
      this.$router.back();
    },
    getListByName(name) {
      if (typeof name !== "string") {
        return;
      }
      //拼接获取数组的方法
      let functionName =
        "get" + name.replace(/^[a-z]/, (initial) => initial.toUpperCase());
      if (typeof this[functionName] === "function") {
        this[functionName]();
      }
    },
    uploadImg(prop) {
      this.form[prop] = "";
    },
    getFile(file, prop) {
      let formData = new FormData();
      formData.append("file", file.raw);
      // 上传图片
      api.imageUp(formData).then((res) => {
        // 工单4为多图上传，需单独调整
        if(prop == "tem_work4"){
          if(!this.form[prop]) this.form[prop] = [];
          file.url = res.data.url;
          this.form[prop].push(file);
        } else {
          this.form[prop] = res.data.url;
          // 工单--图片上传回来后，调用接口直接改订单图片
          // console.log(this.form,'22222哈哈哈哈');
          // console.log(this.orderId,'33333哈哈哈哈');
          // console.log(prop,'哈哈哈哈');
          if (prop == "tem_work") {
            api
              .orderImgUp({
                id: this.orderId,
                url: res.data.url,
                name: "tem_work",
                type: this.type == 13 ? 2 : 1,
              })
              .then((res) => {
                this.$message.success(res.msg || "已更新图片");
              });
          }
          if (prop == "tem_work2") {
            api
              .orderImgUp({
                id: this.orderId,
                url: res.data.url,
                name: "tem_work2",
                type: this.type == 13 ? 2 : 1,
              })
              .then((res) => {
                this.$message.success(res.msg || "已更新图片");
              });
          }
          if (prop == "tem_work3") {
            api
              .orderImgUp({
                id: this.orderId,
                url: res.data.url,
                name: "tem_work3",
                type: this.type == 13 ? 2 : 1,
              })
              .then((res) => {
                this.$message.success(res.msg || "已更新图片");
              });
          }
          //  if (prop == 'tem_img'&&this.type == 13) {
          //   api.orderImgUp({ id: this.orderId, url: res.data.url, name: 'tem_img', type: 2 }).then(res => {
          //     this.$message.success(res.msg || "已更新图片");
          //   })
          // }
          // if (prop == 'tem_img'&&(this.type == 37||this.type == 44||this.type == 32||this.type == 16)) {
          //   api.orderImgUp({ id: this.orderId, url: res.data.url, name: 'tem_img', type: 1 }).then(res => {
          //     this.$message.success(res.msg || "已更新图片");
          //   })
          // }
          // if (prop == 'tem_img'&&!(this.type == 37||this.type == 44||this.type == 32||this.type == 16||this.type == 13||this.type == 14||this.type == 21)) {
          //   api.orderImgUp({ id: this.orderId, url: res.data.url, name: 'tem_img', type: 4 }).then(res => {
          //     this.$message.success(res.msg || "已更新图片");
          //   })
          // }

          if (prop == "tem_card") {
            api
              .orderImgUp({
                id: this.orderId,
                url: res.data.url,
                name: "tem_card",
                type: 4,
              })
              .then((res) => {
                this.$message.success(res.msg || "已更新图片");
              });
          }
          if (prop == "tem_back") {
            api
              .orderImgUp({
                id: this.orderId,
                url: res.data.url,
                name: "tem_back",
                type: 4,
              })
              .then((res) => {
                this.$message.success(res.msg || "已更新图片");
              });
          }
          if (prop == "tem_receive") {
            api
              .orderImgUp({
                id: this.orderId,
                url: res.data.url,
                name: "tem_receive",
                type: 4,
              })
              .then((res) => {
                this.$message.success(res.msg || "已更新图片");
              });
          }
        }
      });
    },

    // 工单4，多图上传
    handleRemove(file, fileList){
      this.form.tem_work4 = fileList;
    },
    // 工单4，多图上传接口提交
    setOrderImgBatch(){
      
      const params = {
        id: this.orderId,
        tem_work4: this.form.tem_work4.map(r => r.url),
      };
      if(params.tem_work4 && params.tem_work4.length == 0){
        return this.$message.warning("请至少上传一张图片");
      }

      orderImgBatch(params).then(res => {
        this.$message.success(res.msg || "已更新图片");
      })
    },
    handleExceed(files, fileList) {
      this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
    },
    handlePreview(file){
      this.dialogImageUrl = file.url;
      this.dialogVisible = true;
    },

    closePreview(event) {
      console.log('event???', event.target.dataset);
      
      // 获取遮罩层dom
      setTimeout(() => {
        let domImageMask = document.querySelector(".el-image-viewer__wrapper");
        if (!domImageMask) {
          return;
        }
        domImageMask.addEventListener("click", (e) => {
          if (
            e.target.parentNode.className ===
              "el-image-viewer__actions__inner" ||
            e.target.parentNode.className === "el-image-viewer__canvas"
          ) {
            return; //如果点击底部菜单，不关闭
          }
          // 点击遮罩层时调用关闭按钮的 click 事件
          document.querySelector(".el-image-viewer__close").click();
        });

        //添加水印
        if (event.target.dataset.watermark) {
          let div = document.createElement("div");
          let text = "";
          if (this.form.card_secret) {
            text += `<p>卡密：${this.form.card_secret}</p>`;
          }
          if (this.form.card_num) {
            text += `<p>卡号：${this.form.card_num}</p>`;
          }
          if (this.form.imei) {
            text += `<p>IMEI码：${this.form.imei}</p>`;
          }
          if (this.form.card_name) {
            text += `<p>销售商家：${this.form.card_name}</p>`;
          }
          div.innerHTML = text;
          div.classList = ["watermark"];
          domImageMask.appendChild(div);
        }
      }, 300);
    },
    getBrandList() {
      api.phoneBrandList().then((res) => {
        this.brandList = res.data || [];
        this.getModelList(this.form.brand_id);
      });
    },
    getModelList(brand_id) {
      api.pullModelList({ brand_id }).then((res) => {
        this.modelList = res.data || [];
      });
    },
    getRAMList() {
      api.phoneRam().then((res) => {
        let list = res.data || [];
        this.RAMList = list.map((item) => item.ram_size);
      });
    },
    getNetStandardList() {
      api.pullNetList().then((res) => {
        let list = res.data;
        this.netStandardList = list.map((item) => item.net_name);
      });
    },
    getChangeMethodList() {
      api.insServiceAn().then((res) => {
        this.changeMethodList = res.data || [];
      });
    },
    getChangeIMEIReasonList() {
      api.replaceType().then((res) => {
        this.changeIMEIReasonList = res.data || [];
      });
    },
    getPhoneStatusList() {
      api.damageConfig().then((res) => {
        this.phoneStatusList = res.data || [];
      });
    },
    getChangeIMEITypeList() {
      api.pullInsTypeList().then((res) => {
        this.changeIMEITypeList = res.data || [];
      });
    },
    getServiceList() {
      api
        .insService({ instype_id: this.formData.order.instype_id })
        .then((res) => {
          this.serviceList = res.data || [];
        });
    },
    getRepairTypeList() {
      api.getFinishType().then((res) => {
        this.repairTypeList = res.data;
      });
    },
    getRepairMethodList() {
      api.getFinishMode().then((res) => {
        this.repairMethodList = res.data;
      });
    },
    getPhoneScreenStatusList() {
      api.damageConfig2().then((res) => {
        let list = res.data || [];
        this.phoneScreenStatusList = list;
        console.log(this.formItems, "888888888");
        console.log(this.formData, "7777777777");
        console.log(this.form, "6666666666");
        // this.form
        let temp = this.formData.order.damage_title
          ? this.formData.order.damage_title.split(",")
          : [];
        console.log("11111111111111", temp);
        let selectedList = [];
        temp.forEach((item) => {
          let findResult = list.find((i) => {
            return i.damage_title === item;
          });
          if (findResult) {
            selectedList.push(findResult.damage_id);
          }
        });
        this.form.damage_title = selectedList;
        console.log(this.form, "55556666666666");
      });
    },
    getIphoneNnhxServeList() {
      api.nnhxService({ type: 1 }).then((res) => {
        this.iphoneNnhxServeList = res.data;
      });
    },
    getAndroidNnhxServeList() {
      api.nnhxService({ type: 2 }).then((res) => {
        this.androidNnhxServeList = res.data;
      });
    },
    getIphoneServeList() {
      api.insService({ instype_id: 3 }).then((res) => {
        this.iphoneServeList = res.data;
      });
    },
    // up+全心服务理赔
    getUpServerList() {
      api.insService({ instype_id: 10 }).then((res) => {
        this.upServerList = res.data;
      });
    },
    getAndroidServeList() {
      api.insService({ instype_id: 2 }).then((res) => {
        this.androidServeList = res.data;
      });
    },
    getPhotoResubmissionTypeList() {
      api.getRelationType().then((res) => {
        this.photoResubmissionTypeList = res.data;
      });
    },
    getLogisticsList() {
      api.getLogisticsList().then((res) => {
        this.logisticsList = res.data;
      });
    },
    selectChange(relate, hx) {
      console.log(relate, "relate",hx);
      
      // console.log(this.form.exa_status);
      // console.log(this.form.fail_exp);
      console.log(this.type);
      if (relate) {
        console.log(213213132);
        if (relate === "model") {
          this.form.model_id = "";
          this.getModelList(this.form.brand_id);
        } else if (relate === "dateRange" || relate === "dateRange2") {
          console.log(123231321);
          if (this.form.exa_status === 1) {
            this.form.add_time = this.form.add_time.replace(/-/g, "/");
            let startTime, endTime;
            // 讯捷PG延长保Plus+ 特殊处理
            if (this.cardIddata.card && this.cardIddata.card.card_id === 102) {
              startTime = dateFormat(
                "YYYY-mm-dd",
                new Date(this.form.add_time)
              ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                return parseInt(RegExp.$1) + 0 + RegExp.$2;
              });
              endTime = dateFormat(
                "YYYY-mm-dd",
                new Date(this.form.add_time)
              ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                return parseInt(RegExp.$1) + 2 + RegExp.$2;
              });
            } else {
              if (this.formData.order.valid_stage === "次年") {
                startTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + 1 + RegExp.$2;
                });
                endTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + 2 + RegExp.$2;
                });
              } else if (this.formData.order.valid_stage === "次年1095") {
                startTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + 1 + RegExp.$2;
                });
                endTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + 4 + RegExp.$2;
                });
              } else if (this.formData.order.valid_stage === "次年730") {
                startTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + 1 + RegExp.$2;
                });
                endTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + 3 + RegExp.$2;
                });
              } else {
                let year = parseInt(this.formData.order.valid_stage);
                startTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(
                    new Date(this.form.add_time).getTime() +
                      1000 * 60 * 60 * 24 * 15
                  )
                );
                endTime = dateFormat(
                  "YYYY-mm-dd",
                  new Date(this.form.add_time)
                ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                  return parseInt(RegExp.$1) + year + RegExp.$2;
                });
              }
            }
            this.temp["dateRange_term_time"] = [startTime, endTime];
            this.form.term_time_start = startTime;
            this.form.term_time_end = endTime;
          } else {
            this.form.fail_exp = "";
            this.temp["dateRange_term_time"] = [];
            this.form.term_time_start = "";
            this.form.term_time_end = "";
          }
          this.$forceUpdate();
        } else if (relate === "Damagecondition") {
          console.log('Damagecondition',this.form.damage_title);
          if (this.form.ins_service_name =='固定补差换机') {
           this.getappleUpPrice()
          }
        }
        if (relate === "dateRange2") {
          if (this.form.exa_status === 1) {
            this.form.add_time = this.form.add_time.replace(/-/g, "/");
            let startTime, endTime;
            if (this.formData.order.vice_valid_stage === "次年") {
              startTime = dateFormat(
                "YYYY-mm-dd",
                new Date(this.form.add_time)
              ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                return parseInt(RegExp.$1) + 1 + RegExp.$2;
              });
              endTime = dateFormat(
                "YYYY-mm-dd",
                new Date(this.form.add_time)
              ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                return parseInt(RegExp.$1) + 2 + RegExp.$2;
              });
            } else {
              let year = parseInt(this.formData.order.vice_valid_stage);
              startTime = dateFormat(
                "YYYY-mm-dd",
                new Date(
                  new Date(this.form.add_time).getTime() +
                    1000 * 60 * 60 * 24 * 15
                )
              );
              endTime = dateFormat(
                "YYYY-mm-dd",
                new Date(this.form.add_time)
              ).replace(/(\d{4})(-\d{2}-\d{2})/, () => {
                return parseInt(RegExp.$1) + year + RegExp.$2;
              });
            }
            this.temp["dateRange_term_time2"] = [startTime, endTime];
            this.form.term_time_start2 = startTime;
            this.form.term_time_end2 = endTime;
          } else {
            this.temp["dateRange_term_time2"] = [];
            this.form.term_time_start2 = "";
            this.form.term_time_end2 = "";
          }
          this.$forceUpdate();
        }
      }
      console.log("hx");
      if (hx === "hx") {
        console.log(123);
        if (this.form.exa_status === 1) {
          if (this.type == 1 || this.type == 4) {
            this.form.fail_exp =
              "碎屏险注册成功，服务自注册成功当天15日后生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交碎屏险理赔申请";
          } else if (
            [35, 5, 36, 37, 40].findIndex((v) => v == this.type) >= 0
          ) {
            this.form.fail_exp =
              "本服务15日后生效，您可享受的各项权益详见实体卡片，如要维修或者换机，请至公众号或者门店做理赔申请，任何疑问您可致电400-1818-819咨询。";
          } else if (this.type == 24) {
            this.form.fail_exp =
              "安卓智选保障计划注册成功，服务自注册成功当天30日后生效，服务期内出现私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交理赔申请";
          } else if (this.type == 26) {
            this.form.fail_exp =
              "苹果智选保障计划注册成功，服务自注册成功当天30日后生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交理赔申请";
          } else if (this.type == 20) {
            this.form.fail_exp =
              "苹果智选保障计划注册成功，服务自注册成功当天15日后生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交理赔申请";
          } else if (this.type == 19) {
            this.form.fail_exp =
              "安卓智选保障计划注册成功，服务自注册成功当天15日后生效，服务期内出现私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交理赔申请";
          } else if (this.type == 28 || this.type == 29) {
            this.form.fail_exp =
              "延保注册成功，服务自注册成功后次年生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交延保理赔申请";
          } else if (this.type == 33) {
            this.form.fail_exp =
              "电池保注册成功，服务自注册成功后次年生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交电池保理赔申请";
          } else if (this.type == 38) {
            this.form.fail_exp =
              "后盾险注册成功，服务自注册成功当天15日后生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交后盾险理赔申请";
          } else if (this.type == 42) {
            this.form.fail_exp =
              "整机维修保障计划注册成功，服务自注册成功当天30日后生效，服务期内出现进液、进水，私拆、私修情况均不在理赔范围之内，需维修时请在公众平台提交理赔申请";
          }
        } else {
          this.form.fail_exp = "";
        }
      }
    },
    getappleUpPrice(){
        console.log(111);
        console.log('this.form.is_up',this.form.is_up);
        
      if(this.form.is_up != ''){
        console.log(222);
        
         api.appleUpPrice({ order_id: this.orderId ,is_up: this.form.is_up,damage_title: this.form.damage_title,new_model:this.form.new_model,new_ram:this.form.new_ram}).then(res=>{
           console.log(res);
          this.form.new_price=res.data.new_price;
          this.form.bare_price=res.data.bare_price;
          this.form.money=res.data.money;
          this.form.claims_money=res.data.claims_money;
       })
      }
      
    },

    saveOriginalImage(prop, objName) {
      api
        .retainOldPic({ mold: this.type, order_id: this.orderId, key: prop })
        .then((res) => {
          this.formData[objName]["old" + prop.replace("tem", "")] =
            res.data.url;
          this.$message.success(res.msg || "保存成功");
        })
        .catch((err) => {});
    },
    refund() {
      this.$confirm("是否发起退款?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        wxRefund({ order_id: this.formData.order.order_id }).then((res) => {
          this.$message.success("退款成功！");
          this.reset();
        });
      });
    },
    dateRangeChange(range, item) {
      this.form[item.props[0]] = range[0];
      this.form[item.props[1]] = range[1];
    },
    reset() {
      this.getOrder();
    },
    viewOrder(type) {
      let { order } = this.formData;
      let params;
      if (type === "register") {
        params = { type: order.order_mold, orderId: order.order_id };
      } else if (type === "claim") {
        params = { type: order.claims_mold, orderId: order.claims_id };
      }
      const { href } = this.$router.resolve({
        name: "订单详情",
        params,
      });
      window.open(href, "_blank");
    },
    confirm() {
      this.logisticsList.forEach((item) => {
        if (item.link == this.form.link) {
          this.form.link_id = item.id;
        }
      });
      let form = JSON.parse(JSON.stringify(this.form));
      form.mold = this.type;
      form.order_id = this.orderId;

      if (Array.isArray(form.damage_title)) {
        let strList = [];
        form.damage_title.forEach((item) => {
          let findResult = this.phoneScreenStatusList.find((p) => {
            return p.damage_id === item;
          });
          if (findResult) {
            strList.push(findResult.damage_title);
          }
        });
        form.damage_title = strList.join(",");
      }
      this.submitShow = true;
      form.claims_imgs = ''
      form.new_price = this.new_price
      const {brand_id,imei,exa_status} = this.form
      // 筛选出不参与总提交的参数 notSubmit为true
      const filterForm = this.formItems.filter(item => item.notSubmit);
      filterForm.forEach(item => {
        delete form[item.prop];
      });
         
      if(brand_id == 1 && exa_status == 1 && this.type == 51){
        api.activationLock({brand_id,imei})
          .then((res) => {
            if(res.code == 2){
            //  if(this.type==51){
                this.$message.error(res.msg );
            //  }else{
            //    this.activationLockMsg = res.msg || '提交失败重新提交'
            //  }
            }else{
            api
            .orderExamine(form)
            .then((res) => {
              this.$message.success(res.msg || "审核成功");
              this.submitShow = false;
            })
            .catch((err) => {
              this.submitShow = false;
            });
            }
              this.submitShow = false;

          })
          .catch((err) => {
              this.submitShow = false;

          });
      }else{
        api
        .orderExamine(form)
        .then((res) => {
          this.$message.success(res.msg || "审核成功");
          this.submitShow = false;
        })
        .catch((err) => {
          this.submitShow = false;
        });
      }
    },
    sendMessageToWX(row) {
      api
        .sendWxPush({ mold: this.type, order_id: this.orderId })
        .then((res) => {
          this.$message.success(res.msg || "推送成功");
        })
        .catch((err) => {});
    },
    queryActiveTime() {
      if (this.imeiData) {
        return;
      }
      api
        .getPhoneMode({
          order_id: this.formData.order.order_id,
        })
        .then((res) => {
          this.imeiData = res.data;
        });
    },

    isShowPriceRange(item){
      let is = false;
      if(item.type === 1){
        const arr = [item.min_price, item.max_price];
        is = arr.some((v) => v && v !== '0' && v !== 0);
      }

      return item.type === 2 || is;
    },
  },
};
</script>

<style scoped lang="scss">
.previewImgBox{
  position: relative;
  .othInfo{
    position: absolute;
    top: 0;
    left: 0;

    max-width: 400px;
    line-height: 1.5em;
    word-break: break-all;
    color: #fff;
    background: #00000080;
    border-radius: 10px;
    padding: 15px;
  }
}

.rong {
  display: inline-block;
  background-color: #f2f9f0;
  color: #80c27f;
  padding: 0 6px;
  border-radius: 6px;
  line-height: 30px;
}

.el-input,
.el-select,
.el-date-picker,
.el-textarea,
.el-date-editor,
::v-deep .el-input__inner {
  width: 500px !important;
}

.preview-img {
  width: 148px;
  height: 148px;
  border-radius: 5px;
}

.head-img {
  width: 50px;
  height: 50px;
}

.img-operation {
  display: flex;
  line-height: 1em;
  align-items: flex-end;

  .notice {
    color: red;
    font-size: 12px;
  }

  .el-button {
    margin-right: 10px;
  }
}

::v-deep .el-upload {
  margin-bottom: 15px;
}

.bottom-btns {
  margin-left: 160px;
}

.picc-callback {
  background: #f5f6fa;
  border-radius: 10px;
  display: flex;
  flex-wrap: wrap;
  padding: 20px;

  .item {
    margin-bottom: 20px;
    display: flex;
    align-items: center;

    .name {
      color: #999;
    }

    .value {
      color: #666;

      .el-button {
        border-radius: 50px;
      }
    }
  }

  .item:nth-child(2n-1) {
    width: 33.3%;
  }

  .item:nth-child(2n) {
    width: 66.6%;
  }
}

.warning span {
  color: red;
  font-size: 18px;
  font-weight: bold;
}

.append {
  margin-left: 20px;

  .el-button:hover {
    color: red;
  }
}

.original-pic {
  position: relative;
  margin-right: 20px;
  margin-bottom: 20px;

  .mark {
    position: absolute;
    top: 0;
    right: 0;
    background: rgba(15, 139, 245, 0.5);
    color: #fff;
    border-bottom-left-radius: 10px;
    padding: 0 10px;
    line-height: 26px;
  }
}

::v-deep .watermark {
  position: absolute;
  left: 220px;
  max-width: 400px;
  line-height: 1.5em;
  word-break: break-all;
  top: 60px;
  color: #fff;
  background: #00000080;
  border-radius: 10px;
  padding: 15px;
}

.detail {
  position: relative;
}

.other-info {
  display: flex;
  position: absolute;
  left: 750px;
  top: 170px;

  .sub-insurance,
  .photo-resubmission {
    width: 300px;

    .title {
      font-weight: bold;
      position: relative;

      &:before {
        content: "";
        display: block;
        width: 4px;
        height: 15px;
        background: #0981ff;
        position: absolute;
        left: -10px;
        top: 50%;
        transform: translateY(-50%);
      }

      .total-cost {
        font-weight: normal;
        font-size: 14px;
        margin-left: 20px;
        color: red;
      }
    }
  }
}
.claims_imgs{
  img{
  width: auto; 
  height: auto; 
  max-width: 100%;
  }
}
.dialog_img{
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
